/* Platform-independent vector arrows, including dynamically mounted carousels. */
(() => {
  'use strict';
  const paths = {'←':'M20 12H4m6-6-6 6 6 6','→':'M4 12h16m-6-6 6 6-6 6','↗':'M5 19 19 5M5 5h14v14','↓':'M12 4v16m-6-6 6 6 6-6'};
  const blocked = 'script,style,svg,textarea,select,option,input,[contenteditable]';
  const convert = node => {
    if (!node.isConnected || !node.parentElement || node.parentElement.closest(blocked) || !/[←→↗↓]/u.test(node.data)) return;
    const fragment = document.createDocumentFragment();
    for (const part of node.data.split(/([←→↗↓])/u)) {
      if (!paths[part]) { fragment.append(document.createTextNode(part)); continue; }
      const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('viewBox','0 0 24 24');
      svg.setAttribute('class','nla-ui-arrow');
      svg.setAttribute('aria-hidden','true');
      svg.setAttribute('focusable','false');
      const path = document.createElementNS(svg.namespaceURI,'path');
      path.setAttribute('d',paths[part]); svg.append(path); fragment.append(svg);
    }
    node.replaceWith(fragment);
  };
  const scan = root => {
    if (root.nodeType === Node.TEXT_NODE) { convert(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(blocked)) return;
    const walker = document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    const nodes=[]; while(walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(convert);
  };
  const start = () => {
    scan(document.body);
    const pending=new Set(); let scheduled=false;
    new MutationObserver(records => {
      for(const record of records) {
        if(record.type==='characterData') pending.add(record.target);
        else record.addedNodes.forEach(node=>pending.add(node));
      }
      if(scheduled || !pending.size) return;
      scheduled=true; requestAnimationFrame(()=>{
        const nodes=[...pending];pending.clear();scheduled=false;nodes.forEach(scan);
      });
    }).observe(document.body,{childList:true,subtree:true,characterData:true});
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
